
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import { EventImageSquare } from "@/components/shared/EventImageSquare";
import { EventImage } from "./imageUploadUtils";

interface ImageItemProps {
  image: EventImage;
  isPrimary: boolean;
  onRemove: (url: string) => void;
  onSetPrimary: (url: string) => void;
}

export const ImageItem = ({ image, isPrimary, onRemove, onSetPrimary }: ImageItemProps) => {
  return (
    <div className="relative w-full">
      <EventImageSquare
        image={image.image_url}
        title={`Event image ${isPrimary ? '(primary)' : ''}`}
        className={isPrimary ? "border-2 border-primary" : ""}
        eventImages={[image]}
      />
      <Button
        variant="destructive"
        size="icon"
        className="absolute -top-2 -right-2 w-6 h-6"
        onClick={() => onRemove(image.image_url)}
      >
        <X className="w-4 h-4" />
      </Button>
      {!isPrimary && (
        <Button
          variant="outline"
          size="icon"
          className="absolute bottom-1 right-1 w-6 h-6 bg-white/70"
          onClick={() => onSetPrimary(image.image_url)}
          title="Set as primary image"
        >
          <span className="text-xs font-bold">★</span>
        </Button>
      )}
    </div>
  );
};
